import { type ChangeEvent, type FormEvent, useState } from 'react';
import { isSupabaseError } from '../../../../constants/supabaseErrors';
import useUpdateSpace from '../../api/useUpdateSpace';
import type { SpaceDatabase } from '../../types';

type Props = {
  space: Pick<SpaceDatabase, 'id' | 'name'>;
};

export default function useSpaceInfoCard(props: Props) {
  const updateSpace = useUpdateSpace();
  const [name, setName] = useState(props.space.name);
  // The space context is not refetched after a rename: track the saved value locally.
  const [savedName, setSavedName] = useState(props.space.name);
  const [serverError, setServerError] = useState<string | null>(null);

  const trimmedName = name.trim();
  const isEmpty = trimmedName === '';
  const isDirty = trimmedName !== savedName;

  function handleNameChange(event: ChangeEvent<HTMLInputElement>) {
    setName(event.target.value);
  }

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (isEmpty || !isDirty) return;

    setServerError(null);
    try {
      await updateSpace.mutateAsync({ spaceId: props.space.id, name: trimmedName });
      setName(trimmedName);
      setSavedName(trimmedName);
    } catch (error: unknown) {
      setServerError(isSupabaseError(error) ? error.message : 'Une erreur est survenue.');
    }
  }

  return {
    name,
    isEmpty,
    canSave: isDirty && !isEmpty,
    isSaving: updateSpace.isPending,
    serverError,
    handleNameChange,
    handleSubmit,
  };
}
